const types = {
  SET_ONE_ANSWER: 'SET_ONE_ANSWER',
  SET_ALL_ACTIONS: 'SET_ALL_ACTIONS',
  SET_ANSWER: 'SET_ANSWER',
  SET_ANSWER_REVISION: 'SET_ANSWER_REVISIONS',
  SET_COSTUMER_NOTIFICATIONS: 'SET_COSTUMER_NOTIFICATIONS',
  SET_ALL_REVIEWS: 'SET_ALL_REVIEWS',
};

export default types;



// WEBPACK FOOTER //
// ./src/store/modules/treatments/mutations-types.js